import React from 'react'
import Routes from './routers'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import { SDK, Bridge, UtilDevice } from '@iskytrip/sdk'
import { env } from './env.config'
// import { UtilUser, } from './utils'
// 全局CSS样式
import './index.css'
// Markdown 文件展示
import './style/markdown.css'

const envConfig = require('./env.config.js')
const isSentry = require('../project.config.js').isSentry

SDK.init(env)

// const promiseFinally = require("promise.prototype.finally");
// promiseFinally.shim()

if (isSentry === env || isSentry === true) {
	Sentry.init({
		environment: envConfig.env,
		// release: envConfig.commit,
		dsn: 'https://4147a6dfadad4acea6bf3248bf2bdac7@onsentry.iskytrip.com/2',
		integrations: [
			new Integrations.RewriteFrames(),
			new Integrations.ExtraErrorData({ depth: 6 }),
		],
	})
}
try {
	if (UtilDevice.isApp()) {
		Bridge.appGetToken((_, userId) => {
			if (userId) {
				window.gio('setUserId', userId)
			} else {
				window.gio('clearUserId')
			}
		})
	} else {
		window.gio('clearUserId')
	}
} catch (e) {
	console.error(e)
}

// 监听农行返回
document.addEventListener(
	'back',
	function(e) {
		window.history.back()
		e.preventDefault() //阻止默认返回行为
	},
	false,
)

// 解决键盘弹出后挡表单的问题
// Bridge.closeAndroidKeyboard(({ height, status }) => {
//     if (
//         status === 1 &&
//         (document.activeElement.tagName.toUpperCase() === 'INPUT' ||
//             document.activeElement.tagName.toUpperCase() === 'TEXTAREA')
//     ) {
//         window.setTimeout(() => {
//             // const scrollTop = document.activeElement.getBoundingClientRect().top
//             // const scrollTop = (window.screen.availHeight - (height / devicePixelRatio)) / 2
//             // // debugger
//             // if (scrollTop > 0) {
//             //     document.body.style.transform = `translateY(-${scrollTop}px)`
//             // }
//             if ('scrollIntoView' in document.activeElement) {
//                 document.activeElement.scrollIntoView()
//             } else {
//                 document.activeElement.scrollIntoViewIfNeeded()
//             }
//         }, 50)
//     }
// })

ReactDOM.render(<Routes />, document.getElementById('app'))
